import { ref, onBeforeUnmount } from 'vue'
import { checkIsKeyupEsc } from '@/lib/utils'

export default function useAuthDialog(escCallback?: () => void) {
	const isShowDialog = ref(false)

	function showDialog() {
		isShowDialog.value = true
	}

	function closeDialog() {
		isShowDialog.value = false
	}

	function pressESC(evt: KeyboardEvent) {
		if (checkIsKeyupEsc(evt) && escCallback) {
			escCallback()
		}
	}

	document.addEventListener('keyup', pressESC)
	showDialog()

	onBeforeUnmount(() => {
		document.removeEventListener('keyup', pressESC)
		closeDialog()
	})

	return {
		isShowDialog,
		showDialog,
		closeDialog,
	}
}
